import type { TulipReserve } from "../../models/token-lending/tulip/reserves";

export const calculateTulipBorrowApr = (currentUtilization: number, reserve: TulipReserve): number => {
  let borrowApr = 0;

  const maxRateBelowThreshold = reserve.degenBorrowRate;
  if (currentUtilization <= 50) {
    borrowApr = 15 * (currentUtilization / 50) + 0;
  } else if (currentUtilization > 50 && currentUtilization <= 90) {
    borrowApr = ((currentUtilization - 50) / 40) * (maxRateBelowThreshold - 15) + 15;
  } else if (currentUtilization > 90) {
    borrowApr =
      ((currentUtilization - 90) / 10) * (reserve.maxBorrowRate - maxRateBelowThreshold) + maxRateBelowThreshold;
  }
  return borrowApr;
};
